import './AdConfigsPanel.pcss';
import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useRouter from 'use-react-router';
import { Switch, Route } from 'react-router-dom';
import { Dispatch } from 'redux';
import { AdConfigDetail } from '../../components/AdConfigDetail/AdConfigDetail';
import { MessengerAdDetail } from '../../components/MessengerAdDetail/MessengerAdDetail';
import '../../../common/css/sharedPanel.scss';
import { StoreState } from '@mm/state/store-interfaces';
import {
  activeChatbotSelector,
  activeFacebookPageIdSelector,
} from '@mm/state/selectors/viewSelectors';
import AdAccountCRUDActions from '@mm/state/actions/AdAccountCRUDActions';
import AudiencesCRUDActions from '@mm/state/actions/AudiencesCRUDActions';
import { activeTemplatesSelector } from '@mm/state/selectors/adConfigSelectors';
import { BotBuilderRoutes } from '../../../../../routes/bot-builder-routes';

const AdConfigsPanel = () => {
  const { history, match } = useRouter();
  const chatbot = useSelector(activeChatbotSelector);
  const fbPageId = useSelector(activeFacebookPageIdSelector);
  const adAccounts = useSelector(
    (state: StoreState) => state.adAccounts.entities,
  );
  const audiences = useSelector(
    (state: StoreState) => state.audiences.entities,
  );
  const dispatch: Dispatch<StoreState> = useDispatch();

  useEffect(() => {
    (async () => {
      if (!adAccounts || adAccounts.length === 0) {
        await dispatch(
          AdAccountCRUDActions.retrieveAll(fbPageId, false, '', true),
        );
      }
      if (!audiences || audiences.length === 0) {
        await dispatch(AudiencesCRUDActions.retrieveAll(chatbot.id));
      }
    })();
  }, []);

  const renderDetails = useCallback(() => {
    return (
      <>
        <AdConfigDetail />
      </>
    );
  }, []);

  const renderSyncDetails = useCallback(() => {
    return (
      <>
        <MessengerAdDetail />
      </>
    );
  }, []);

  const renderIndex = () => {
    const url = BotBuilderRoutes.campaigns.getLink({
      chatbotId: chatbot.id,
      kind: 'ctm_ads',
    });
    if (url) {
      history.push(url);
    }
    return <></>;
  };

  return (
    <div className="shared-panel">
      <Switch>
        <Route exact path={match.url} render={renderIndex} />
        <Route exact path={`${match.path}/:adsType`} render={renderIndex} />
        <Route
          path={`${match.path}/sync/edit/:messengerAdId`}
          render={renderSyncDetails}
        />
        <Route path={`${match.path}/edit/:adConfigId`} render={renderDetails} />
      </Switch>
    </div>
  );
};

export default AdConfigsPanel;
